import React, { useState } from "react";
import { mergeStyles } from "../utils/utilStyles";

const baseStyle = {
  backgroundColor: "bg-slate-600",
  textColor: "text-white",
  borderColor: "border-slate-600",
};

const Tooltip = ({
  children = null,
  text = "",
  direction = "left",
  width = "w-60 md:w-80",
  textAlignment = "text-start",
  overrideStyle = {},
}) => {
  const [opacity, setOpacity] = useState(0);

  const mergedStyle = mergeStyles(baseStyle, overrideStyle);

  // if children is null use the info-icon
  if (!children) {
    children = <img src="/assets/icons/info-icon.png" alt="info-icon" className="min-w-5 size-5" />;
  }

  const getTooltipPositionClass = (direction) => {
    switch (direction) {
      case "top":
        return "bottom-full left-1/2 transform -translate-x-1/2 mb-2";
      case "bottom":
        return "top-full left-1/2 transform -translate-x-1/3 mt-2";
      case "left":
        return "right-full top-1/2 transform -translate-y-1/3 mr-2";
      case "right":
      default:
        return "left-full top-1/2 transform -translate-y-1/3 ml-2";
    }
  };

  return (
    <div className={`relative inline-block`}>
      <div
        onMouseEnter={() => setOpacity(1)} // Show tooltip
        onMouseLeave={() => setOpacity(0)} // Hide tooltip
      >
        {children}
      </div>
      {text && opacity == 1 && (
        <span
          className={`absolute ${width} ${mergedStyle.backgroundColor} ${textAlignment} ${
            mergedStyle.textColor
          } border ${
            mergedStyle.borderColor
          } px-4 py-2 z-50 rounded-md text-[12px] md:text-[14px] transition-opacity duration-300 ${getTooltipPositionClass(
            direction
          )}`}
          style={{ opacity }}
        >
          {text}
        </span>
      )}
    </div>
  );
};

export default Tooltip;
